var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job-fitting card pt-xs pb-xs pr-sm"},[_vm._v("\n    "+_vm._s(((_vm.fitting.title) + " | " + (_vm.fitting.amount) + " " + _vm.unit))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }